import { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios"

const MACHINERYITENS = [
  "gerador",
  "corteFrango",
  "linguica",
  "frangoCarcaca",
  "batata",
]

const UserContext = createContext();

export const UserProvider = ({ children }) => {

  const [industry, setIndustry] = useState({})
  const [marketPlace, setMarketPlace] = useState(null)
  const [user, setUser] = useState(null);
  const [signed, setSigned] = useState(false)
  const [rodada, setRodada] = useState(null)
  const [jogo, setJogo] = useState(null)


  const isNeededSetupIndustry = useMemo(() => {
    if (!industry) return false
    return Object.keys(industry)
      .filter(item => MACHINERYITENS.includes(item))
      .every(item => industry[item] === 0)
  }, [industry])

  async function DoAForcedGet() {
    initialSetup()
  }

  async function Login(data) {
    localStorage.setItem('@App:user', JSON.stringify(data));
    DoAForcedGet()

  }

  function Logout() {
    localStorage.removeItem('@App:user');
    localStorage.removeItem('@App:currentUserGame')
    localStorage.removeItem('@App:industria')
    localStorage.removeItem('@App:marketplace')

    setUser(null);
    setSigned(false);
    setIndustry(null);
    setJogo(null);
    setRodada(null);
  }

  const initialSetup = async () => {
    try {
      const currentUser = JSON.parse(localStorage.getItem("@App:user"))
      if (!currentUser) return

      if (!user) {
        setSigned(true)
        setUser(currentUser)
      }

      const currentGame = await axios.get(`${process.env.REACT_APP_BASE_URL}/jogo/obterJogoAtivo`)
      const currentUserGame = await axios.get(`${process.env.REACT_APP_BASE_URL}/usuario/obterJogo/${currentUser?.usuario}/${currentGame?.data?.jogo}`)
      if (currentUserGame?.data?.usuarioJogo) {
        localStorage.setItem('@App:jogo', JSON.stringify(currentGame.data))
        localStorage.setItem('@App:currentUserGame', JSON.stringify(currentUserGame.data))
        setJogo(currentGame.data)
        let _industry = null
        let _marketplace = null
        if (currentUserGame?.data?.industria) {
          _industry = await axios.get(`${process.env.REACT_APP_BASE_URL}/industria/obter/${currentUserGame.data?.industria}`)
          setIndustry(_industry.data)
          localStorage.setItem('@App:industria', JSON.stringify(_industry.data));
        }

        if (currentUserGame?.data?.supermercado) {
          _marketplace = await axios.get(`${process.env.REACT_APP_BASE_URL}/supermercado/obter/${currentUserGame.data?.supermercado}`)
          setMarketPlace(_marketplace.data)
          localStorage.setItem('@App:marketplace', JSON.stringify(_marketplace.data))
        }

        const currentRound = await axios.get(`${process.env.REACT_APP_BASE_URL}/rodada/obterRodadaAtiva/${currentGame?.data?.jogo}`)
        setRodada(currentRound?.data)
        localStorage.setItem('@App:rodada', JSON.stringify(currentRound?.data))
        return
      }

      return
    } catch (e) {
      console.log("Initial setup error =>", e);
    }
  }

  useEffect(() => {
    initialSetup()
  }, [])

  return (
    <UserContext.Provider
      value={{
        user,
        signed,
        Login,
        Logout,
        rodada,
        setRodada,
        DoAForcedGet,
        setJogo,
        jogo,
        industry,
        marketPlace,
        setMarketPlace,
        setIndustry,
        isNeededSetupIndustry
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
